import { Linkedin, Quote } from "lucide-react";

export default function FounderCard({ founder }) {
  const reverse = founder.imagePosition === "right";

 const ImageSection = (
  <div
    className="
      relative
      h-full
      overflow-visible
      bg-[#101B2E]
    "
  >
    {/* Blue Glow */}

    <div
      className="
        absolute
        left-1/2
        top-1/2
        -translate-x-1/2
        -translate-y-1/2
        h-[220px]
        w-[220px]
        rounded-full
        bg-[#168BFF]/20
        blur-[70px]
      "
    />

    {/* PNG */}

    <img
      src={founder.image}
      alt={founder.name}
      className={`
        absolute
        bottom-0
        z-10
        h-[342px]
        object-contain
        object-bottom
        transition-transform
        duration-500
        ${reverse ? "right-[-15px]" : "left-[-15px]"}
      `}
    />
  </div>
);

  const ContentSection = (
    <div className="flex flex-col justify-center px-5 py-4">

      {/* Badge */}

      <p
        className="
          text-[8px]
          font-semibold
          uppercase
          tracking-[0.22em]
          text-[#21A6E9]
        "
      >
        {founder.badge}
      </p>

      {/* Name */}

      <h2
        className="
          mt-2
          whitespace-nowrap
          text-[22px]
          lg:text-[24px]
          font-black
          uppercase
          leading-none
          tracking-tight
          text-white
        "
      >
        {founder.name}
      </h2>

      {/* Role */}

      <p
        className="
          mt-2
          text-[14px]
          leading-5
          text-slate-300
        "
      >
        {founder.role}
      </p>

      {/* Divider */}

      <div className="mt-2 h-[2px] w-8 rounded-full bg-[#21A6E9]" />

      {/* Quote */}

      <div className="mt-3 flex gap-2">

        <Quote
          size={14}
          className="mt-1 shrink-0 text-[#21A6E9]"
        />

        <p
          className="
            max-w-[220px]
            text-[12px]
            italic
            leading-5
            text-slate-400
          "
        >
          {founder.quote}
        </p>

      </div>

      {/* LinkedIn */}

      <a
        href={founder.linkedin}
  target="_blank"
  rel="noreferrer"
  className="
    mt-4
    flex
    h-7
    w-7
    items-center
    justify-center
    rounded-md
    border
    border-white/10
    bg-white/5
    transition-all
    duration-300
    hover:border-[#21A6E9]
    hover:bg-[#21A6E9]
    hover:text-[#020617]
  "
>
  <Linkedin size={14} className="text-[#21A6E9]" />
</a>

    </div>
  );

  return (
    <div
      className="
        relative
        overflow-visible
        rounded-[18px]
        border
        border-white/10
        bg-[#0B1322]
      "
    >
      <div
        className={`
          grid
          min-h-[250px]
          items-center
          ${reverse ? "grid-cols-[45%_55%]" : "grid-cols-[55%_45%]"}
        `}
      >
        {reverse ? (
          <>
            {ContentSection}
            {ImageSection}
          </>
        ) : (
          <>
            {ImageSection}
            {ContentSection}
          </>
        )}
      </div>
    </div>
  );
}